import { connect } from 'react-redux';

import Badge from 'components/generic/Badge.component';
import Icon from 'components/generic/Icon.component';
import SALON_STRIPE_STATUS from 'constants/stripeStatus.const';
import { useTranslation } from 'providers/GILT.provider';
import { useNcobSettings } from 'providers/NcobSettings.provider';
import { selectCurrentSalonRestrictedToCriticalServices } from 'selectors/currentSalon.selectors';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';

const StripeStatusBadges = ({ tag, isRestrictedToCriticalServices }) => {
  const { t } = useTranslation();
  const { value: valueSettings } = useNcobSettings();
  const { salonStripeAccountStatus } = valueSettings || {};

  const isComplete = salonStripeAccountStatus === SALON_STRIPE_STATUS.complete && !isRestrictedToCriticalServices;
  const isUnverified = salonStripeAccountStatus === SALON_STRIPE_STATUS.complete && isRestrictedToCriticalServices;
  const isIncomplete = salonStripeAccountStatus === SALON_STRIPE_STATUS.incomplete;
  const isRestricted = salonStripeAccountStatus === SALON_STRIPE_STATUS.restricted;
  const isNoAccount = salonStripeAccountStatus === SALON_STRIPE_STATUS.noAccount;

  return (
    <div data-bem="StripeStatusBadges" data-tag={fromAnyToTrimmed(tag)}>
      {isComplete && (
        <Badge variant="success" withIcon height="sm">
          <Icon variant="stripeBlue" width="md" />
          {t('composite.stripeStatusBadges.complete')}
        </Badge>
      )}

      {isUnverified && (
        <Badge variant="restricted" withIcon height="sm">
          <Icon variant="xCircleSolid" width="md" />
          {t('composite.stripeStatusBadges.unverified')}
        </Badge>
      )}

      {isIncomplete && (
        <Badge variant="attention" withIcon height="sm">
          <Icon variant="xCircleSolid" width="md" />
          {t('composite.stripeStatusBadges.incomplete')}
        </Badge>
      )}

      {isRestricted && (
        <Badge variant="restricted" withIcon height="sm">
          <Icon variant="xCircleSolid" width="md" />
          {t('composite.stripeStatusBadges.restricted')}
        </Badge>
      )}

      {isNoAccount && (
        <Badge variant="attention" withIcon height="sm">
          <Icon variant="xCircleSolid" width="md" />
          {t('composite.stripeStatusBadges.noAccount')}
        </Badge>
      )}
    </div>
  );
};

const StripeStatusBadgesHoc = connect((state) => ({
  isRestrictedToCriticalServices: selectCurrentSalonRestrictedToCriticalServices(state),
}))(StripeStatusBadges);

export default StripeStatusBadgesHoc;
